import { render } from "./Menu.vue?vue&type=template&id=a323ba7c"
const script = {}

import exportComponent from "/Users/devgroup/work/hanbyul/hanbyeol/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__